import React, { FC, ReactNode } from "react"
import { ReactComponent as WarnIcon } from "icons/lib/warn.svg"

interface ErrorFallbackProps {
    title: string
    errorDetail?: string
    children?: ReactNode
}

export const ErrorFallback: FC<ErrorFallbackProps> = ({
    title,
    errorDetail,
    children
}: ErrorFallbackProps) => {
    return (
        <div className="w-full h-full bg-rhino-100 flex flex-col items-center justify-center">
            <div className="text-rhino-800 text-lg p-4 pb-2">
                <WarnIcon className="inline-block w-6 h-6 mr-1" />
                {title}
            </div>
            <p className="text-rhino-800 mb-4">{errorDetail}</p>
            {children}
        </div>
    )
}
